// Sidebar collapse hook — manages collapsed state with localStorage
// persistence per user. Shared across all GMS agent web apps.

import { useState, useCallback } from 'react';

const STORAGE_PREFIX = 'sidebar-collapsed';

export function useSidebarCollapse(userId: string | undefined) {
  const storageKey = userId ? `${STORAGE_PREFIX}-${userId}` : STORAGE_PREFIX;

  const [collapsed, setCollapsed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(storageKey) === 'true';
    } catch {
      return false;
    }
  });

  const toggle = useCallback(() => {
    setCollapsed(prev => {
      const next = !prev;
      try {
        localStorage.setItem(storageKey, String(next));
      } catch { /* ignore */ }
      return next;
    });
  }, [storageKey]);

  return { collapsed, toggle } as const;
}
